import React from "react";
import styles from "./circularprogress.module.scss";

const CircularProgress = () => {
  return (
    <div className={styles.loader}>
      <span class="loader"></span>
    </div>
  );
};

export default CircularProgress;
